<template>
  <div>
    <date-range-select v-model="dateRange"/>
    <f7-list no-hairlines v-if="reportType === 'expense'">
      <f7-block-title>Include only transactions tagged:</f7-block-title>
      <f7-list-item>
        <tag-entry style="width: 100%;" v-model="tagFilter.tags"/>
      </f7-list-item>
    </f7-list>
    <hairline/>
  </div>
</template>

<script>
  import moment from 'moment'
  import DateRangeSelect from '@/components/DateRangeSelect'
  import TagEntry from '@/components/TagEntry'
  import Hairline from '@/components/Hairline'

  export default {
    name: 'ReportFilter',
    components: {
      Hairline,
      TagEntry,
      DateRangeSelect,
    },
    props: {
      value: {
        type: Object,
        default () {
          return {
            fromMonth: 1,
            fromYear: 2016,
            toMonth: moment().month() + 1,
            toYear: moment().year(),
            tags: [],
          }
        },
      },
      reportType: String,
    },
    data () {
      return {
        dateRange: {
          fromMonth: this.value.fromMonth,
          fromYear: this.value.fromYear,
          toMonth: this.value.toMonth,
          toYear: this.value.toYear,
        },
        tagFilter: {
          tags: [],
        },
      }
    },
    computed: {
      months () {
        return moment.months()
      },
      years () {
        // would love to find something like python's range function to replace this.
        const years = []
        for (let i = 2016; i <= moment().year(); i++) {
          years.push(i)
        }
        return years
      },
    },
    watch: {
      dateRange: {
        deep: true,
        immediate: true,
        handler () {
          this.$emit('input', {...this.dateRange, ...this.tagFilter})
        },
      },
      tagFilter: {
        deep: true,
        immediate: true,
        handler () {
          this.$emit('input', {...this.dateRange, ...this.tagFilter})
        },
      },
    },
  }
</script>

<style scoped>

</style>
